import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import { FilesApiService } from 'src/app/core/services/api/files-api.service';
import { CaseSearchParams } from 'src/app/shared/models/cases/caseSearchParams';
import { Client } from 'src/app/shared/models/clients/client';
import { Case, CaseWrite } from 'src/app/shared/models/cases/case';
import { FilesFilterComponent } from 'src/app/shared/files-filter/files-filter.component';
import { FileSummaryModalComponent } from 'src/app/shared/file-summary-modal/file-summary-modal.component';
import { NewFileService } from 'src/app/core/services/new-file.service';
import { CaseClient } from 'src/app/shared/models/cases/caseClient';
import { CaseLite } from 'src/app/shared/models/cases/caseLite';
import { PrintService } from 'src/app/core/services/print.service';

@Component({
  selector: 'app-client-files',
  templateUrl: './client-files.component.html',
  styleUrls: ['./client-files.component.scss']
})
export class ClientFilesComponent implements OnInit {
  client: Client;
  public cases: CaseLite[] = []
  public filters = new CaseSearchParams();

  public count = 0;
  columnMode: ColumnMode;
  selected = [];
  SelectionType = SelectionType;

  @ViewChild('filterModal') filterModal: FilesFilterComponent;
  @ViewChild('fileSummaryModal') fileSummaryModal: FileSummaryModalComponent;
  @ViewChild('myTable') table: any;
  constructor(
    private apiService: FilesApiService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private router: Router,
    private newFileService: NewFileService,
    private printService: PrintService,
  ) {
    this.route.parent.data.subscribe(resolversData => {
      this.client = resolversData.client;
      this.filters.clients.push(this.client.id);
    });
  }

  ngOnInit(): void {
    this.loadClientFiles();
  }

  loadClientFiles() {
    this.spinner.show()
    this.apiService.getFilesLite(this.filters).subscribe(
      f => {
        this.cases = f.results;
        this.count = f.count;
        this.spinner.hide();
      }
    )
  }

  onPage(page) {
    this.filters.page = page.offset + 1;
    this.loadClientFiles();
  }

  onSort(sort) {
    debugger;
  }

  onSearch(e: KeyboardEvent) {
    if (e.keyCode === 13) {
      this.filters.page = 1;
      this.filters.search = (e.target as HTMLInputElement).value;
      this.loadClientFiles();
    }
  }

  onSelect({ selected }) {
    this.router.navigate([`/files/${selected[0].id}`], { relativeTo: this.route });
  }

  openFilterModal() {
    this.filterModal.openModal();
  }

  onFilterApply(e) {
    this.filterModal.close();
    this.filters = e.p;
    this.filters.page = 1;
    this.loadClientFiles();
  }

  onFilterReset() {
    this.filterModal.close();
    this.filters = new CaseSearchParams();
    this.filters.clients = [this.client.id];
    this.loadClientFiles();
  }

  onSelectFileSummary(fileId: number) {
    this.spinner.show();
    this.apiService.getFileSummary(fileId).subscribe(
      c => {
        this.fileSummaryModal.open(c, true);
        this.spinner.hide();
      }
    )
  }

  newFile() {
    const caseClient = new CaseClient();
    caseClient.clientId = this.client.id;
    caseClient.client = this.client;
    this.newFileService.file = new Case();
    this.newFileService.file.clients.push(caseClient);
    this.router.navigate(['/files/new'], { relativeTo: this.route });
  }


  print() {
    this.printService.data = { cases: this.cases };
    this.printService.printDocument('files-report')
  }


}
